// TODO: detect if menu items are slotted and add class to ul

import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'cwru-form-input',
  styleUrl: 'form.css',
  shadow: false,
})
export class FormInput {
  @Prop() inputType: string = 'text';
  @Prop() inputName: string = 'inputName';
  @Prop() inputId: string = 'inputID';
  @Prop() inputValue: string = '';
  @Prop() inputSize: number = 100;

  render() {
    return (
      <div class="form_response">
        <input type={this.inputType} id={this.inputId} name={this.inputName} value={this.inputValue} size={this.inputSize} autocomplete="off"></input>
        <slot />
      </div>
    );
  }
}
